export default ({
  namespaced: true,
  state: {
    profile: JSON.parse(localStorage.getItem('profile'))
  },
  getters: {
    // get the full object state of the profile
    profile: state => state.profile,
    // get the full name of the profile
    fullName: ({profile}) => `${profile.first_name} ${profile.middle_name} ${profile.last_name}`
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile
      localStorage.setItem('profile', JSON.stringify(profile)); 
    },
    removeProfile(state) {
      state.profile = {
        id: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        nickname: null,
        profile_image: null,
        mobile_number: null,
        phone_number: null,
        email: null,
        address: null,
        user_id: null,
        created_at: null,
        updated_at: null,
        deleted_at: null
      }
    }
  },
  actions: {
    async signOut(state) {
      await state.commit('removeProfile');
    }
  }
})